import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

export default function RealizedGainsTooltipContent() {
  return (
    <PDSFlexBox
      m={SIZE.s8}
      flexDirection="column"
      gap={SIZE.s8}
      backgroundColor={COLOR.black}
    >
      <PDSText color={COLOR.white} fontWeight="bold">
        Realized Gains
      </PDSText>
      <PDSText color={COLOR.white} fontWeight="semibold">
        It may take up to 31 days to accurately reflect realized gains.
      </PDSText>
    </PDSFlexBox>
  )
}
